import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'loader-blocks',
	templateUrl: './loader-blocks.component.html',
	imports: [ CommonModule, FormsModule ]
})
export class LoaderBlocksComponent implements OnInit {
	
	@Input() controller: any;
	@Input() controllerAs: any;
	@Input() templateUrl: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		
	}
	
}